'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _utilsGenerateCssTransform = require('./utils/generateCssTransform');

var _utilsGenerateCssTransform2 = _interopRequireDefault(_utilsGenerateCssTransform);

var ContainerRenderer = function ContainerRenderer(props) {

	var containers = props.containers || [];
	var boxes = props.boxes || [];

	var dataBinder = props.dataBinder;
	var ctx = props.ctx;
	var node = props.node;
	var widgets = props.widgets;

	var elementName = node.elementName;

	var customStyles = ctx["styles"] || {};

	var styles = {
		left: props.left,
		top: props.top,
		height: props.height,
		width: props.width,
		position: props.position || 'relative'
	};

	var nodeProps = node.props;
	var nodeBindings = node.bindings || {};

	//apply custom styles
	var customStyle = ctx["styles"] && ctx["styles"][elementName];
	if (customStyle !== undefined) nodeProps = _lodash2['default'].merge(_lodash2['default'].cloneDeep(customStyle), nodeProps);

	//apply node props
	if (dataBinder !== undefined) nodeProps = props.widgetRenderer.bindProps(_lodash2['default'].cloneDeep(nodeProps), nodeBindings.bindings, dataBinder, true);

	var containerComponent = widgets[elementName] || 'div';

	return _react2['default'].createElement(
		'div',
		{ style: styles },
		containers.length !== 0 ? _react2['default'].createElement(containerComponent, nodeProps, containers.map(function (container, index) {

			var key = container.name + index;

			var left = container.style.left === undefined ? 0 : parseInt(container.style.left, 10);
			var top = container.style.top === undefined ? 0 : parseInt(container.style.top, 10);

			//je potreba merge
			var childProps = _lodash2['default'].cloneDeep(container.props) || {};
			var childBindings = container.bindings || {};

			//apply custom styles
			var childCustomStyle = ctx["styles"] && ctx["styles"][container.elementName];
			if (childCustomStyle !== undefined) childProps = _lodash2['default'].merge(_lodash2['default'].cloneDeep(childCustomStyle), childProps);

			//apply node props
			if (dataBinder !== undefined) childProps = props.widgetRenderer.bindProps(childProps, childBindings.bindings, dataBinder, true);

			var childComponent = widgets[container.elementName] || 'div';

			//propagete width and height to child container props
			if (!childProps.width && !!container.style.width) childProps.width = container.style.width;
			if (!childProps.height && !!container.style.height) childProps.height = container.style.height;

			return _react2['default'].createElement(childComponent, _lodash2['default'].extend({ child: true, key: key }, childProps), _react2['default'].createElement(ContainerRenderer, { key: key,
				index: index,
				left: left,
				top: top,
				height: container.style.height,
				width: container.style.width,
				position: container.style.position || 'relative',
				boxes: container.boxes,
				containers: container.containers,
				node: container,
				parent: props.parent,
				dataBinder: props.dataBinder,
				ctx: props.ctx,
				widgets: props.widgets,
				widgetRenderer: props.widgetRenderer }));
		}, undefined)) : null,
		boxes.map(function (box, index) {

			var key = box.name + index;

			//propagate width and height to widget props
			if (!box.props.width && !!box.style.width) box.props.width = box.style.width;
			if (!box.props.height && !!box.style.height) box.props.height = box.style.height;

			if (box.style.transform !== undefined) {
				box.style.WebkitTransform = (0, _utilsGenerateCssTransform2['default'])(box.style.transform);
				box.style.transform = (0, _utilsGenerateCssTransform2['default'])(box.style.transform);
			}

			box.style.position = elementName === "Cell" ? 'relative' : 'absolute';

			var elName = box.elementName;
			var widget = _react2['default'].createElement(props.widgetRenderer, {
				widget: props.widgets[elName],
				node: box,
				customStyle: customStyles[elName],
				dataBinder: dataBinder
			}, null);

			return _react2['default'].createElement(
				'div',
				{ key: key, style: box.style },
				_react2['default'].createElement(
					'div',
					{ id: box.name },
					widget
				)
			);
		}, undefined)
	);
};
exports['default'] = ContainerRenderer;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-html-pages-renderer/lib/ContainerRenderer.js
 ** module id = 484
 ** module chunks = 0
 **/